<template>
  <div>
    <a-modal
      v-model="visible"
      :title="
        id == 5
          ? blankId
            ? type == 'show'
              ? '查看空白模板'
              : '编辑空白模板'
            : '新增空白模板'
          : type == 'edit'
          ? '文档编辑'
          : '文档查看'
      "
      centered
      :keyboard="false"
      :maskClosable="false"
      width="auto"
      :getContainer="getContainer"
    >
      <div class="forms">
        <File1 ref="file1" v-if="id == 1" />
        <File2 ref="file2" :disabled="type == 'show'" v-if="id == 2" />
        <File3 ref="file3" :disabled="type == 'show'" v-if="id == 3" />
        <File4 ref="file4" :disabled="type == 'show'" v-if="id == 4" />
        <FileBlank ref="fileBlank" :disabled="type == 'show'" v-if="id == 5" />
      </div>
      <div slot="footer">
        <a-button size="large" @click="handleCancel">关闭</a-button>
        <a-button
          size="large"
          v-if="type == 'edit' && (id == 2 || id == 3 || id == 4 || id == 5)"
          type="primary"
          @click="handleOk"
          :loading="confirmLoading"
          >保存</a-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import File1 from "./file1";
import File2 from "./file2";
import File3 from "./file3";
import File4 from "./file4";
import FileBlank from "./fileBlank";
import {
  fileInfo,
  fileInfoSet,
  filesBlankInfo,
  filesBlankAdd,
  filesBlankEdit,
} from "@/request/file";
export default {
  components: { File1, File2, File3, File4, FileBlank },
  data() {
    return {
      blankId: "",
      visible: false,
      confirmLoading: false,
      id: "",
      type: "edit", //edit修改show查看
      info: {
        valueAtitle: "",
        valueA1: "",
        valueBtitle: "",
        valueB1: "",
        valueB2: "",
        valueB3: "",
        valueB1_sign: "", //公司负责人签字
        valueB2_sign: "", //项目部负责人签字
        valueB3_sign: "", //班组签字
        valueCtitle: "",
        valueC1: "",
      },
    };
  },
  methods: {
    init(id, type, blankId) {
      this.visible = true;
      this.id = id;
      this.type = type;
      if (!!blankId) {
        this.blankId = blankId;
        this.getBlankInfo();
      } else {
        this.getInfo();
      }
    },
    //获取空白模板信息
    getBlankInfo() {
      filesBlankInfo(this.blankId).then((res) => {
        this.$refs.fileBlank.title = res.data.title;
      });
    },
    //获取配置项
    getInfo() {
      fileInfo().then((res) => {
        console.log(res);
        this.info = res.data;
        if (this.id == 2) {
          this.$refs.file2.valueAtitle = res.data.valueAtitle;
          this.$refs.file2.valueA1 = res.data.valueA1;
        }
        if (this.id == 3) {
          this.$refs.file3.valueBtitle = res.data.valueBtitle;
          this.$refs.file3.valueB1 = res.data.valueB1;
          this.$refs.file3.valueB2 = res.data.valueB2;
          this.$refs.file3.valueB3 = res.data.valueB3;
          this.$refs.file3.valueB1_sign = res.data.valueB1_sign;
          this.$refs.file3.valueB2_sign = res.data.valueB2_sign;
          this.$refs.file3.valueB3_sign = res.data.valueB3_sign;
        }
        if (this.id == 4) {
          this.$refs.file4.valueCtitle = res.data.valueCtitle;
          this.$refs.file4.valueC1 = res.data.valueC1;
        }
      });
    },
    handleOk() {
      if (this.id == 2) {
        this.info.valueAtitle = this.$refs.file2.valueAtitle;
        this.info.valueA1 = this.$refs.file2.valueA1;
      }
      if (this.id == 3) {
        this.info.valueBtitle = this.$refs.file3.valueBtitle;
        this.info.valueB1 = this.$refs.file3.valueB1;
        this.info.valueB2 = this.$refs.file3.valueB2;
        this.info.valueB3 = this.$refs.file3.valueB3;
        this.info.valueB1_sign = this.$refs.file3.valueB1_sign;
        this.info.valueB2_sign = this.$refs.file3.valueB2_sign;
        this.info.valueC1 = this.$refs.file3.valueC1;
      }
      if (this.id == 4) {
        this.info.valueCtitle = this.$refs.file4.valueCtitle;
        this.info.valueC1 = this.$refs.file4.valueC1;
      }
      if (this.id == 5) {
        if (!this.$refs.fileBlank.title) {
          return this.$message.info("请输入空白模板的标题");
        }
        const form = {
          id: this.blankId,
          title: this.$refs.fileBlank.title,
        };
        const fn = !form.id ? filesBlankAdd : filesBlankEdit;
        this.confirmLoading = true;
        fn(form)
          .then((res) => {
            this.visible = false;
            this.confirmLoading = false;
            this.$refs.fileBlank.title = "";
            this.$notification.success({
              message: form.id ? "修改空白模板成功" : "新增空白模板成功",
            });
            this.$emit("ok");
          })
          .catch(() => (this.confirmLoading = false));
        return;
      }
      this.confirmLoading = true;
      fileInfoSet(this.info)
        .then(() => {
          this.visible = false;
          this.confirmLoading = false;
          this.$notification.success({
            message: "修改成功",
          });
          this.$emit("ok");
        })
        .catch(() => (this.confirmLoading = false));
    },
    handleCancel() {
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.forms {
  width: 600px;
  min-height: 70vh;
}
</style>